import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * Display chip. Status chips are text only — no dots, no icons (skill §5).
 * The color carries the meaning.
 */
export function Chip({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
        className,
      )}
    >
      {children}
    </span>
  );
}
